module.exports = __webpack_public_path__ + "img/01_content_03.4a047388.png";